import { useQuery } from '@tanstack/react-query';
import { faro } from '@grafana/faro-web-sdk';
import { useClient } from './useClient';

import {
  GetFunctionsQuery,
  GetFunctionsResponse,
} from '@hud/portal-dtos/webapp-function.dto';
import { PORTAL_BASE } from '../consts';

export const FUNCTIONS_ID = 'functions';

export default function useFunctions(query: GetFunctionsQuery) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [FUNCTIONS_ID, query],
    queryFn: async () => {
      const startTime = new Date();
      const response = await client.get<GetFunctionsResponse>(
        `${PORTAL_BASE}/functions`,
        {
          params: query,
        },
      );
      faro.api.pushMeasurement({
        type: 'getFunctions',
        values: {
          time: new Date().getTime() - startTime.getTime(),
        },
      });
      return GetFunctionsResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
